/* WORKFOLK: role + garment filters on design walls, garment-aware size prompts,
   "Go to bag" after adding, and -/+ quantity steppers. Loaded after badge.js. */
(function () {
  'use strict';
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var scopes = [];
  all('[data-wall-filter], [data-garment-filter]').forEach(function (el) {
    var scope = el.closest('.board, .coll') || document;
    if (scopes.indexOf(scope) === -1) scopes.push(scope);
  });

  scopes.forEach(function (scope) {
    var state = { role: '', garment: '' };
    var items = all('.wall__item', scope);
    var count = scope.querySelector('[data-wall-count]');

    function apply(label) {
      var shown = 0;
      items.forEach(function (it) {
        var ok = (!state.role || it.getAttribute('data-role') === state.role) &&
                 (!state.garment || it.getAttribute('data-garment') === state.garment);
        it.hidden = !ok;
        if (ok) shown++;
      });
      if (count) {
        count.textContent = (state.role || state.garment)
          ? 'Showing ' + shown + (shown === 1 ? ' design' : ' designs') + (label ? ' for ' + label : '') + '.'
          : '';
      }
    }

    function bind(group, attr, key) {
      if (!group) return;
      var btns = all('button[' + attr + ']', group).map(function (b) {
        var c = b.cloneNode(true);
        b.parentNode.replaceChild(c, b);
        return c;
      });
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
          state[key] = b.getAttribute(attr) || '';
          var labels = [];
          all('[data-wall-filter] [aria-pressed="true"], [data-garment-filter] [aria-pressed="true"]', scope).forEach(function (p) {
            var v = p.getAttribute('data-filter') || p.getAttribute('data-garment');
            if (v) labels.push(p.textContent.trim());
          });
          apply(labels.join(' · '));
        });
      });
    }

    bind(scope.querySelector('[data-wall-filter]'), 'data-filter', 'role');
    bind(scope.querySelector('[data-garment-filter]'), 'data-garment', 'garment');
  });

  // badge.js says "The cut is oversized" when no size is picked; reword it for other garments.
  all('form[data-buy]').forEach(function (form) {
    var g = form.getAttribute('data-garment');
    var status = form.querySelector('[data-status]');
    if (!status || g === 'oversized' || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (/cut is oversized/i.test(status.textContent)) {
        status.textContent = 'Choose a size first. Take your usual size.';
      }
    }).observe(status, { childList: true, characterData: true, subtree: true });
  });

  // After a successful add, the button becomes "Go to bag" and takes you there.
  // Changing colour, size or quantity turns it back into "Add to bag".
  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
  all('form[data-buy]').forEach(function (form) {
    var btn = form.querySelector('[data-add]');
    var status = form.querySelector('[data-status]');
    if (!btn || !status || !window.MutationObserver) return;
    var addLabel = btn.getAttribute('data-label-add') || 'Add to bag';
    function goMode() {
      form.setAttribute('data-added', '');
      btn.removeAttribute('aria-disabled');
      btn.textContent = 'Go to bag';
      btn.classList.add('buy__add--go');
    }
    function reset() {
      if (!form.hasAttribute('data-added')) return;
      form.removeAttribute('data-added');
      btn.classList.remove('buy__add--go');
      setTimeout(function () { if (btn.textContent === 'Go to bag') btn.textContent = addLabel; }, 0);
    }
    new MutationObserver(function () {
      if (/added to your bag/i.test(status.textContent)) setTimeout(goMode, 0);
    }).observe(status, { childList: true, characterData: true, subtree: true });
    form.addEventListener('change', reset);
    form.addEventListener('input', reset);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[data-buy][data-added]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = cartUrl;
    }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[data-buy][data-added] [data-add]');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); window.location.href = cartUrl; }
  }, true);

  // Bag: - / + steppers instead of typing a number. A change submits the bag (badge.js listens on [data-qty]).
  all('.stepper').forEach(function (st) {
    var input = st.querySelector('[data-qty]');
    if (!input) return;
    all('[data-step]', st).forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10), max = parseInt(input.max || '20', 10);
        var v = Math.max(min, Math.min(max, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10)));
        if (String(v) === input.value) return;
        input.value = v;
        all('[data-step]', st).forEach(function (o) { o.disabled = true; });
        st.setAttribute('aria-busy', 'true');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product page: - / + around the quantity box too.
  all('.buy__qty input[name="quantity"]').forEach(function (input) {
    if (input.closest('.stepper')) return;
    var max = parseInt(input.max || '20', 10) || 20;
    input.max = max; input.min = 1; input.readOnly = true;
    var wrap = document.createElement('div');
    wrap.className = 'stepper';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Quantity');
    function mk(step, txt, label) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'stepper__btn'; b.textContent = txt;
      b.setAttribute('aria-label', label); b.setAttribute('data-step', step);
      return b;
    }
    var minus = mk(-1, '−', 'One fewer'), plus = mk(1, '+', 'One more');
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(minus); wrap.appendChild(input); wrap.appendChild(plus);
    function sync() {
      var v = parseInt(input.value, 10) || 1;
      minus.disabled = v <= 1; plus.disabled = v >= max;
    }
    [minus, plus].forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, Math.min(max, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)));
        if (String(v) === input.value) return;
        input.value = v; sync();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    sync();
  });
})();
